import type { StudentSchedulingDetails } from '@/features/scheduling/api/getStudentsSchedulingDetails';
import { getStudentEnrollmentDetails } from '@/features/scheduling/utils/getStudentEnrollmentDetails';
import { getStudentRemainingSessions } from '@/features/scheduling/utils/getStudentRemainingSessions';
import type { EnrollmentType } from '@/types/enrollment';
import type { Student } from '@/types/student';
import type { StudentsSessionDetails } from '../../ScheduleDialog/context/ScheduleFlowContext';

export const getStudentsSessionsData = (
  students: Student[],
  studentsConfig: StudentSchedulingDetails[],
  studentSessionDetails: StudentsSessionDetails[],
  displayMonth: Date,
  timeZone: string,
) => {
  const result: Record<string, { enrollmentType: EnrollmentType | undefined; remainingSessions: number }> = {};

  for (const student of students) {
    const enrollmentId = studentSessionDetails.find((detail) => detail.studentId === student.id)?.enrollmentId;

    if (!enrollmentId) {
      result[student.id] = { enrollmentType: undefined, remainingSessions: 0 };
      continue;
    }

    const enrollment = getStudentEnrollmentDetails(studentsConfig, student.id, enrollmentId);

    if (!enrollment) {
      result[student.id] = { enrollmentType: undefined, remainingSessions: 0 };
      continue;
    }

    result[student.id] = {
      enrollmentType: enrollment.type,
      remainingSessions: getStudentRemainingSessions(studentsConfig, student.id, enrollmentId, displayMonth, timeZone) ?? 0,
    };
  }

  return result;
};
